<template>
    <div class="warmingtrayWrp">

        <div class="in">
            <h4>
                <b> <translate item="WarmingTray.Caption" /></b>
            </h4>
            <warmingTrayOverlayWarmingTray v-bind:key="warmingTray.id" v-for="warmingTray in warmingTrays" :warming-tray="warmingTray" >

            </warmingTrayOverlayWarmingTray>

        </div>
        <div class="alert-buttons panel">
            <div class="text-left">
                <div class="loading" v-if="loading">Please wait...</div>
            </div>            
            <div class="text-right">
                <div class="btn btn-dark" :class="{disabled :loading }" v-bind:disabled="loading" v-on:click="close"><translate item="General.Close" /></div>
                <div class="btn btn-success" :class="{disabled :loading }" v-bind:disabled="loading" v-on:click="apply"><translate item="General.Apply" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    import translate from '../components/translate'
    import Swal from "sweetalert2";
    import WarmingTrayRepository from '../repositories/WarmingTrayRepository';
    import warmingTrayOverlayWarmingTray from '../components/WarmingTrayOverlayWarmingTray'
   
    export default {

        name: 'WarmingTrayOverlay',

        data: function () {
            return {
                warmingTrays: {},
                loading: true,
                falseValue: false
            }
        },

        components: { translate, warmingTrayOverlayWarmingTray },


        methods: {
            apply: function () {
                if (this.loading) {
                    return;
                }
                this.loading = true;
                WarmingTrayRepository.applyWarmingTrays(this.warmingTrays).then(() => { this.loading = false; Swal.close(); });
            },

            close: function () {
                Swal.close();
            }
        },

        computed: {

        },

        mounted: function () {
            this.loading = true;
            WarmingTrayRepository.getWarmingTraysForOverlay().then(a => {
                this.warmingTrays = a; this.loading = false;
            });
        }
    };

</script>

<style scoped>
</style>